type IpAllowlistValidation = { valid: true } | { message: string; valid: false };

export function validateIpAllowlist(
  isRestricted: boolean,
  ipAllowlist?: string[]
): IpAllowlistValidation {
  if (!isRestricted) {
    return { valid: true };
  }

  if (!ipAllowlist?.some((entry) => entry.trim().length > 0)) {
    return {
      message: 'Add at least one IP or CIDR entry to restrict Live Forum access by IP',
      valid: false,
    };
  }

  return { valid: true };
}
